import { WorkflowNotification } from "components/navigation/customComponents/NotificationItem";
import { produce } from "immer";
import { Store } from "reducers/rootReducer";

type State = {
  selectedNotificationItems: WorkflowNotification[] | null;
  numberOfNotifications: number | null;
};

const initialState: State = {
  selectedNotificationItems: null,
  numberOfNotifications: null,
};

const SET_NotificationItems = "app/homemodule/SET_NotificationItems";
const RESET_NotificationItems = "app/homemodule/RESET_NotificationItems";
const UPDATE_NumberOfNotifications =
  "app/homemodule/UPDATE_NumberOfNotifications";

type Action =
  | {
      type: typeof SET_NotificationItems;
      payload: WorkflowNotification[];
    }
  | {
      type: typeof RESET_NotificationItems;
    }
  | {
      type: typeof UPDATE_NumberOfNotifications;
      payload: number;
    };

export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case SET_NotificationItems:
        draft.selectedNotificationItems = action.payload;
        break;
      case RESET_NotificationItems:
        draft.selectedNotificationItems = null;
        break;
      case UPDATE_NumberOfNotifications:
        draft.numberOfNotifications = action.payload;
        break;
      default:
        return state;
    }
  });
}

export const setNotificationItems = (
  payload: WorkflowNotification[]
): Action => ({
  type: SET_NotificationItems,
  payload: payload,
});

export const resetNotificationItems = (): Action => ({
  type: RESET_NotificationItems,
});

export const updateNumberOfNotifications = (payload: number): Action => ({
  type: UPDATE_NumberOfNotifications,
  payload,
});

export const selectNotificationItems = (app: Store) =>
  app.workflowNotifications.selectedNotificationItems;
export const selectNumberOfNotifications = (app: Store) =>
  app.workflowNotifications.numberOfNotifications;
